export enum EPagePermission {
  SuperAdmin = 'Super Admin',
  Usage = 'Usage',
  CustomAccount = 'Custom Account',
  DeleteEmail = 'Delete Email',
  PaymentPlatform = 'Payment Platform',
  Products = 'Products',
  CustomerPayment = 'Custom Payment',
  Moderation = 'Moderation',
  Template = 'Template',
  VoiceCategory = 'Voice Category',
  Voice = 'Voice',
}

export enum EBtnPermission {
  LessProduct = 'Less Product',
}
